// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { Fragment } from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import {
  FormGroup,
  ControlLabel,
  FormControl,
  Checkbox,
} from 'react-bootstrap';
import NumericInput from '../../utils/FormWidgets/NumericInput';
import ContentPanel from '../../utils/ContentPanel';
import Rq from '../../utils/FormWidgets/RequireField';
import Switcher from '../../utils/FormWidgets/Switcher';

export default class AdditionalDetails extends React.Component {
  onCostTypeChange = type => {
    console.log(type);
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { handleEventChange, event } = this.props;
    handleEventChange({
      ...event,
      costType: type,
    });
  };

  render() {
    const {
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      event,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      handleChange,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      switchSecret,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      partyMembers,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      handleCurrencyChange,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      changeMembers,
    } = this.props;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    const personActive = event.costType === 'per person' ? 'budget-active' : '';
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    const partyActive = event.costType === 'per party' ? 'budget-active' : '';
    return (
      <Fragment>
        {
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          <ContentPanel header='Additional Details'>
            <FormGroup
              controlId='cost'
              style={{
                paddingLeft: '0px',
                display: 'inline-block',
                width: '177px',
              }}
            >
              <ControlLabel>Est. Budget</ControlLabel>
              {
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                <NumericInput
                  onChange={handleCurrencyChange}
                  // TODO: Fix this the next time the file is edited.
                  // eslint-disable-next-line react/prop-types
                  value={event.cost}
                  type='$'
                />
              }
            </FormGroup>
            <div
              style={{
                display: 'inline-block',
                marginTop: '30px',
                verticalAlign: 'top',
                marginLeft: '30px',
              }}
            >
              <div
                className={`budget-button budget-left ${personActive}`}
                onClick={() => this.onCostTypeChange('per person')}
              >
                per person
              </div>
              <div
                className={`budget-button budget-right ${partyActive}`}
                onClick={() => this.onCostTypeChange('per party')}
              >
                per party
              </div>
            </div>
            <div className='clearfix' />
            <FormGroup controlId='dressCode'>
              <ControlLabel>Dress Code</ControlLabel>
              <FormControl
                type='text'
                onChange={handleChange}
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line react/prop-types
                value={event.dressCode}
              />
            </FormGroup>
            {
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              <Switcher
                onChange={switchSecret}
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line react/prop-types
                checked={event.isSecret}
                style={{ display: 'inline-block', verticalAlign: 'top' }}
              />
            }
            <div
              style={{
                display: 'inline-block',
                marginLeft: '15px',
                marginBottom: '20px',
              }}
            >
              <span style={{ fontSize: '18px' }}>Secret Event</span>
              <br />
              <span
                style={{ fontSize: '14px', color: 'rgba(79, 79, 79, 0.7)' }}
              >
                This will hide it from your BACH
              </span>
            </div>
            <FormGroup controlId='attendees'>
              <ControlLabel>
                Attendees
                <Rq />
              </ControlLabel>
              <Checkbox
                val='all'
                onChange={changeMembers}
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line react/prop-types
                checked={event.autojoin}
              >
                All party members{' '}
                <span
                  style={{ fontSize: '14px', color: 'rgba(79, 79, 79, 0.7)' }}
                >
                  (including members who have yet to join)
                </span>
              </Checkbox>
              {/* TODO: Fix this the next time the file is edited. */}
              {/* eslint-disable-next-line react/prop-types */}
              {partyMembers.map(member => (
                <Checkbox
                  key={member.id}
                  val={member.id}
                  onChange={changeMembers}
                  checked={
                    // TODO: Fix this the next time the file is edited.
                    // eslint-disable-next-line react/prop-types
                    event.attendees.map(att => att.id).indexOf(member.id) >= 0
                  }
                >
                  {member.name}
                  {member.status === 'pending' && (
                    <span
                      style={{
                        color: '#ff9900',
                        fontSize: '14px',
                        marginLeft: '10px',
                      }}
                    >
                      pending
                    </span>
                  )}
                </Checkbox>
              ))}
            </FormGroup>
            <FormGroup controlId='eventDescription'>
              <ControlLabel>Additional Notes</ControlLabel>
              <FormControl
                componentClass='textarea'
                onChange={handleChange}
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line react/prop-types
                value={event.eventDescription || ''}
              />
            </FormGroup>
          </ContentPanel>
        }
      </Fragment>
    );
  }
}
